'use client'

import { useEffect } from 'react'
import { Button, Dialog, Navigation, Text, Divider } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { viewScreenEvent } from '@marketplace-web/complaints/complaints-data'

import RefundDetails from './RefundDetails'

type Props = {
  transactionId: number
  isOpen: boolean
  onClose: () => void
}

const RefundProgressModal = ({ transactionId, isOpen, onClose }: Props) => {
  const translate = useTranslate('conversation.actions.refund_progress.modal')
  const { track } = useTracking()

  useEffect(() => {
    if (!isOpen) return

    track(viewScreenEvent({ screen: 'refund_status' }))
  }, [track, isOpen])

  const renderModalNavigation = () => {
    return (
      <>
        <Navigation
          right={
            <Button
              styling={Button.Styling.Flat}
              iconName={X24}
              inline
              onClick={onClose}
              testId="refund-progress-modal-close-button"
            />
          }
          body={<Text as="h2" type={Text.Type.Title} text={translate('title')} />}
        />
        <Divider />
      </>
    )
  }

  const renderRefundDetails = () => <RefundDetails transactionId={transactionId} />

  return (
    <Dialog show={isOpen}>
      {renderModalNavigation()}
      {renderRefundDetails()}
    </Dialog>
  )
}

export default RefundProgressModal
